import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_2 = ["href"]

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemEdit',
  props: {
    linkUrl: null
  },
  setup(__props: any) {




const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (__props.linkUrl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: __props.linkUrl,
          class: "text-14 text-dusty-grey hover:text-dusty-grey c-magic-line c-magic-line--underline"
        }, _toDisplayString(_unref(labels).lineItemEditLinkText), 9, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})